import LegerHead from "../../../../../components/categories/siakad/laporan_adab/leger/HomeHead"
export default function Home() {
  
  return (
    <LegerHead />
  );
}